/** Istilah operasional delman — konsisten di PWA Delman. */
export const delmanTerms = {
  appName: 'Superoti Delman',
  modules: {
    trip: 'Sesi kirim',
    kitchenTransfer: 'Antar dapur',
    handover: 'QR handover',
    pickup: 'Pickup retur',
    attendance: 'Absensi',
  },
  auth: {
    flowSteps: ['Aktivasi', 'Login PIN'] as const,
  },
  login: {
    title: 'Login PIN',
    subtitle: 'Masukkan PIN 6 digit untuk mulai sesi kirim.',
    helper: 'Isi 6 digit PIN untuk lanjut.',
    submit: 'Masuk',
    submitting: 'Memverifikasi…',
  },
  trip: {
    pageTitle: 'Sesi kirim hari ini',
    subtitle: (delmanName: string, kitchenName: string, dateLabel: string) =>
      `${delmanName} · ${kitchenName} · ${dateLabel}`,
    loading: 'Memuat sesi kirim',
    loadError: 'Gagal memuat sesi — periksa koneksi lalu coba lagi.',
    retry: 'Coba lagi',
    refreshAria: 'Perbarui sesi kirim',
    summaryLine: (stops: number, pcs: number) => `${stops} toko · ${pcs} pcs`,
    returnsSuffix: (count: number) => ` · ${count} retur`,
    pcs: (qty: number) => `${qty} pcs`,
    start: 'Mulai sesi kirim',
    complete: 'Selesai sesi kirim',
    whatIsTrip:
      'Sesi kirim = satu putaran keluar dapur: antar ke beberapa toko, pantau penerimaan, pickup retur, lalu tutup sesi. Satu hari bisa beberapa sesi.',
    inProgress: 'Berjalan',
    ready: 'Siap berangkat',
    completed: 'Selesai',
    itinerary: 'Pilih toko',
    preStartHint:
      'Pilih toko untuk mulai sesi. Setelah berjalan, tap toko untuk detail kiriman dan handover QR.',
    emptyStops: 'Belum ada pengiriman untuk sesi ini. Minta dapur menyerahkan barang ke delman.',
    waitingNextDispatch:
      'Belum ada perintah kirim berikutnya. Minta dapur menyerahkan barang untuk sesi berikutnya.',
    storePickerHint: 'Tap toko untuk handover QR atau lihat status.',
    storePickerReadyHint: 'Tap toko untuk mulai sesi kirim.',
    summaryStripReady: 'Tap toko untuk mulai sesi kirim',
    summaryStartedFrom: (storeName: string, done: number, total: number) =>
      `Dimulai dari ${storeName} · ${done}/${total} toko selesai`,
    storeStartedHere: 'Sesi dimulai di sini',
    storeInProgress: 'Sedang dikerjakan',
    completeChecklistTitle: 'Syarat tutup sesi kirim',
    completeCheckDelivery: (done: number, total: number) => `${done}/${total} toko selesai terima`,
    completeCheckReturns: (picked: number, waiting: number) =>
      waiting > 0 ? `${picked} di-pickup · ${waiting} menunggu` : `${picked} retur di-pickup`,
    completeCheckReturnsAction: 'Ke scan retur',
    attendanceRequired: 'Check-in absensi dulu sebelum mulai sesi kirim.',
    attendanceRequiredBanner: 'Belum check-in hari ini — absen dulu sebelum mulai sesi kirim.',
    attendanceRequiredAction: 'Ke absensi',
    yesterdayTripTitle: 'Sesi kemarin',
    yesterdayTripSummary: (id: string, stops: number) => `${id} · ${stops} toko · selesai`,
    sessionHistoryTitle: 'Sesi selesai hari ini',
    sessionHistoryItem: (sessionNo: number, stops: number) => `Sesi ${sessionNo} · ${stops} toko · selesai`,
    betweenSessionsHint:
      'Sesi kirim selesai. Tetap status masuk — tunggu perintah berikutnya dari dapur. Tidak perlu check-out istirahat.',
    storeActionStartTrip: 'Tap untuk mulai sesi kirim',
    storeActionViewDetail: 'Lihat detail kiriman',
    storeActionMonitor: 'Pantau penerimaan',
    storeActionSummary: 'Lihat ringkasan',
    startConfirmWithStore: (storeName: string) =>
      `Mulai sesi kirim menuju ${storeName}. Pastikan barang sudah di kendaraan sebelum berangkat.`,
    completeHint: 'Selesaikan semua pengiriman dan pickup retur sebelum menutup sesi kirim.',
    completeBlockedDelivery: 'Masih ada toko yang belum selesai menerima barang.',
    completeBlockedReturn: 'Masih ada retur belum di-pickup.',
    completeSummaryTitle: 'Ringkasan sebelum tutup sesi',
    closedTitle: 'Sesi kirim selesai.',
    closedRemainder: (qty: number) => `Sisa in transit: ${qty} pcs → area retur dapur`,
    closedFooter: 'Dapur akan melakukan penerimaan retur fisik.',
    checkoutPromptTitle: 'Saat pulang, check-out absensi',
    checkoutPromptBody: 'Check-out hanya saat pulang — tidak perlu antar sesi kirim.',
    checkoutPromptAction: 'Ke absensi',
    returnBanner: (count: number) => `${count} retur menunggu scan pickup`,
    returnBannerAction: 'Buka scan QR retur toko',
    starting: 'Memulai…',
    progress: (done: number, total: number) => `${done}/${total} toko selesai`,
    startConfirmTitle: 'Mulai sesi kirim?',
    startConfirmBody: 'Pastikan barang sudah di kendaraan sebelum berangkat.',
    startConfirmPrimary: 'Ya, mulai sesi kirim',
    completeSheetTitle: 'Selesai sesi kirim',
    completeSheetDelivery: 'Pengiriman selesai',
    completeSheetReturns: 'Retur di-pickup',
    completeSheetTransit: 'Sisa in transit',
    completeSheetTransitHint: '→ Area retur dapur',
    completeSheetPrimary: 'Lanjut — masukkan PIN',
    completeSheetMockTransit: (qty: number) => `${qty} pcs (estimasi)`,
    startedToast: (storeName: string) => `Sesi kirim dimulai — ${storeName}.`,
    completedToast: (qty: number) => `Sesi kirim selesai. Sisa ${qty} pcs ke area retur dapur.`,
    startSheet: {
      tripId: 'ID sesi',
      startedStore: 'Toko dimulai',
      storeCount: 'Jumlah toko',
      totalGoods: 'Total barang',
    },
    pickedReturnsValue: (count: number) => `${count} dokumen`,
    pin: {
      completeTitle: 'PIN konfirmasi',
      completeDescription: 'Masukkan PIN untuk menyelesaikan sesi kirim hari ini.',
    },
    errors: {
      deviceRequired: 'Perangkat tidak terdaftar.',
    },
  },
  kitchenTransfer: {
    pageTitle: 'Antar dapur',
    pageSubtitle: 'Kiriman dari dapur lain — tampilkan QR untuk dapur tujuan scan.',
    whatIsTransfer:
      'Delman antar barang antar dapur. Setelah sampai, tampilkan QR agar kepala dapur tujuan scan di tablet PWA.',
    loading: 'Memuat kiriman antar dapur',
    loadError: 'Gagal memuat kiriman — periksa koneksi lalu coba lagi.',
    retry: 'Coba lagi',
    refreshAria: 'Perbarui daftar kiriman',
    emptyTitle: 'Belum ada kiriman antar dapur',
    fromKitchen: (name: string) => `Dari ${name}`,
    toKitchen: (name: string) => `→ ${name}`,
    handoverPageTitle: 'QR dapur tujuan',
    dropLoading: 'Memuat detail kiriman',
    dropNotFound: 'Kiriman tidak ditemukan.',
    backToList: 'Kembali ke antar dapur',
    showQr: 'Tampilkan QR',
    refreshQr: 'Perbarui QR',
    qrExpired: 'QR kedaluwarsa',
    qrCreateError: 'Gagal buat QR',
    refreshDropAria: 'Perbarui status kiriman',
    empty: 'Belum ada kiriman antar dapur hari ini. Tunggu dapur asal serahkan barang ke delman.',
    dropAction: 'Tap untuk QR dapur tujuan',
    dropPending: 'Belum selesai',
    dropDone: 'Sudah diterima',
    dropScanned: 'Sudah discan dapur',
    handoverHint: 'Tampilkan QR agar kepala dapur tujuan bisa scan di tablet PWA.',
    handoverDone: 'Dapur tujuan sudah menyelesaikan penerimaan.',
    handoverScanned: 'QR sudah discan dapur tujuan. Menunggu konfirmasi PIN penerimaan.',
    expiryLabel: (time: string) => `Kedaluwarsa ${time}`,
  },
  delivery: {
    whatIsDelivery:
      'Pantau progress penerimaan toko per kiriman. Qty terima diisi toko — delman tidak mengubah.',
    loading: 'Memuat detail pengiriman',
    loadError: 'Gagal memuat detail — periksa koneksi lalu coba lagi.',
    retry: 'Coba lagi',
    refreshAria: 'Perbarui detail pengiriman',
    lineShipped: 'Kirim',
    lineReceived: 'Terima',
    statusLabel: 'Status',
    showQr: 'Tampilkan QR handover',
    receivingStatus: 'Status penerimaan toko',
    readOnly: 'Delman tidak mengubah qty — hanya pantau progress toko.',
    notFound: 'Pengiriman tidak ditemukan.',
    backToTrip: 'Kembali ke sesi kirim',
    totalShipped: (qty: number) => `Total kirim: ${qty} pcs`,
    completedBanner: 'Toko sudah menyelesaikan penerimaan.',
    damagedNote: 'Damaged/shortage hanya diisi toko — delman pantau saja.',
    receivingDraft: 'Draft (toko sedang input)',
    receivingWaiting: 'Menunggu scan toko',
    receivingNone: 'Belum dimulai',
    simulateDevComplete: '[Dev] Simulasi toko selesai terima',
  },
  handover: {
    title: 'QR handover',
    subtitle: 'Tampilkan QR ke kasir toko untuk scan penerimaan barang.',
    whatIsHandover:
      'QR handover = bukti serah terima ke toko. Kasir toko scan QR ini untuk mulai input penerimaan di App Toko.',
    tripLoading: 'Memuat data pengiriman',
    tripLoadError: 'Gagal memuat pengiriman — periksa koneksi lalu coba lagi.',
    retry: 'Coba lagi',
    refreshTripAria: 'Perbarui status pengiriman',
    create: 'Buat QR handover',
    refresh: 'Perbarui QR',
    loading: 'Membuat QR…',
    createHint: 'Tekan tombol di bawah untuk membuat QR.',
    expiredTitle: 'QR kedaluwarsa',
    expiredHint: 'Buat ulang sebelum toko scan.',
    storeDraft: 'Toko sedang input penerimaan.',
    waitingScan: 'Menunggu toko scan QR…',
    storeScannedToast: (storeName: string) => `${storeName} scan QR — receiving draft dibuat.`,
    storeCompletedToast: (storeName: string) => `${storeName} selesai terima barang.`,
    qrReadyToast: 'QR handover siap ditampilkan ke toko.',
    ttlExpired: 'Kedaluwarsa — regenerate QR',
    ttlRemaining: (min: number, sec: string) => `Berlaku ${min}:${sec}`,
    fullscreen: 'Layar penuh',
    fullscreenClose: 'Tutup layar penuh',
    fullscreenDialogAria: 'QR handover layar penuh',
    regenerate: 'Buat ulang QR',
    viewDeliveryDetail: 'Lihat detail pengiriman',
    simulateReceive: 'Simulasi toko scan & terima',
    simulateReceiveProcessing: 'Memproses…',
    simulateReceiveSuccess: 'Seolah-olah toko sudah scan & terima barang.',
    simulateReceiveFailed: 'Simulasi terima gagal.',
    simulateDevScan: '[Dev] Simulasi toko scan QR (lokal)',
  },
  returnPickup: {
    pageTitle: 'Pickup retur',
    whatIsPickup:
      'Toko tampilkan QR retur → delman scan di HP → konfirmasi PIN. Retur ikut ke dapur saat sesi kirim ditutup.',
    loading: 'Memuat data retur',
    loadError: 'Gagal memuat data retur — periksa koneksi lalu coba lagi.',
    retry: 'Coba lagi',
    refreshAria: 'Perbarui daftar retur',
    liveBadge: 'Live',
    cameraInactivePin: 'Konfirmasi PIN untuk menyelesaikan pickup.',
    pinFallback: 'Masukkan PIN delman.',
    incompleteData: 'Data pickup tidak lengkap.',
    selectPendingHint: (code: string) => `Scan QR toko untuk ${code} (SUPEROTI:RP:…)`,
    pendingItemLine: (store: string, items: number) => `${store} · ${items} item · ke dapur`,
    pickedItemLine: (store: string, time: string) => `${store} · ${time}`,
    emptyPending: 'Tidak ada retur menunggu pickup saat ini.',
    scan: 'Scan QR retur toko',
    confirm: 'Konfirmasi pickup',
    intro: 'Toko tampilkan QR retur → delman scan → konfirmasi PIN.',
    cameraHint: 'Arahkan kamera ke QR retur dari App Toko',
    cameraUnsupported: 'Kamera QR tidak didukung di browser ini — tempel kode manual di bawah.',
    cameraPermissionDenied: 'Izinkan akses kamera di pengaturan browser untuk scan QR.',
    tripNotStarted: 'Mulai sesi kirim dulu sebelum pickup retur.',
    scanned: (code: string) => `QR terbaca: ${code}`,
    cameraInactiveTrip: 'Mulai sesi kirim dulu — kamera scan akan aktif otomatis.',
    manualToggle: 'Input manual kode QR',
    pasteLabel: 'Tempel kode QR retur',
    pastePlaceholder: 'SUPEROTI:RP:<return_id>:<token>',
    pendingTitle: (count: number) => `Menunggu pickup (${count})`,
    pickedTitle: 'Sudah di-pickup',
    backToTrip: 'Kembali ke sesi kirim',
    emptyScan: 'Masukkan atau scan kode QR retur.',
    unknownQr: 'QR retur tidak dikenali atau sudah di-pickup.',
    pinTitle: 'PIN konfirmasi pickup',
    pinDescription: (id: string, items: number, store: string) =>
      `Konfirmasi pickup ${id} · ${items} item dari ${store}.`,
    successToast: 'Retur berhasil di-pickup.',
  },
  sync: {
    queued: 'Tersimpan di HP — akan disinkronkan saat online',
    offline: 'Offline',
    online: 'Online',
    pending: (count: number) => `${count} antrean`,
    flushing: 'Menyinkronkan…',
    tapToRetry: 'Ketuk untuk coba sinkronkan ulang',
    statusTitle: 'Status koneksi HP delman',
    offlineBanner: 'Tidak ada internet',
    offlineBannerDetail: 'Data tetap aman di HP. Akan terkirim otomatis saat online.',
    offlinePending: (count: number) => `${count} operasi menunggu sinkron`,
  },
  pwa: {
    installTitle: 'Pasang aplikasi di HP',
    installBody: 'Akses sesi kirim lebih cepat dari layar utama — tanpa buka browser.',
    installAction: 'Install',
    installDismiss: 'Nanti',
  },
  attendance: {
    pageTitle: 'Absensi',
    deviceNotActivated: 'Perangkat belum teraktivasi.',
    activateAction: 'Aktivasi HP',
    cancel: 'Batal',
    continueConfirm: 'Lanjut konfirmasi',
    continuePin: 'Lanjut ke PIN',
    retakeSelfie: 'Ulangi selfie',
    selfieRequired: 'Ambil selfie terlebih dahulu.',
    incompleteData: 'Data absensi tidak lengkap.',
    checkoutButtonSuffix: 'selfie + PIN',
    stepSelfie: 'Selfie',
    stepConfirm: 'Konfirmasi',
    stepPin: 'PIN',
    confirmPhotoAlt: (name: string) => `Konfirmasi ${name}`,
    fieldDelman: 'Delman',
    fieldKitchen: 'Dapur',
    fieldAction: 'Aksi',
    fieldTime: 'Waktu',
    selfOnlyHint: 'Absensi pribadi — hanya untuk akun delman di HP ini.',
    statusToday: 'Status hari ini',
    shift: 'Shift',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    checkInVerb: 'masuk',
    checkOutVerb: 'keluar',
    notYet: 'Belum check-in',
    onShift: 'Sedang shift',
    finished: 'Selesai hari ini',
    selfiePinRequired: 'Selfie + PIN wajib',
    selfieTitle: (action: string) => `${action} — ambil selfie`,
    confirmHint: 'Pastikan foto sudah benar sebelum PIN.',
    pinTitle: (action: string) => `Konfirmasi ${action}`,
    pinDescription: (name: string, action: string) => `PIN ${name} untuk ${action}.`,
    submit: 'Submit absensi',
    onTime: 'Tepat waktu',
    late: 'Terlambat',
    duration: (label: string) => `Durasi shift: ${label}`,
    offlineNote:
      'Butuh internet untuk mengirim selfie. Jika koneksi putus setelah selfie terkirim, absensi disimpan di HP dan dikirim otomatis saat online.',
    stayOnShiftHint:
      'Antar sesi kirim, tetap status masuk. Check-out hanya saat pulang — tidak perlu check-out istirahat.',
    tripNotCompleted:
      'Masih ada sesi kirim yang aktif. Selesaikan semua pengiriman dan tutup sesi dulu sebelum check-out.',
    tripNotCompletedAction: 'Ke sesi kirim',
    statusLoading: 'Memuat status absensi…',
    pendingSync: (action: string) => `${action} menunggu sinkronisasi`,
  },
  activation: {
    title: 'Aktivasi HP delman',
    subtitle: 'Masukkan kode aktivasi sekali pakai dari Admin HO.',
    codeLabel: 'Kode aktivasi',
    codeHelper: 'Ketik atau tempel 6 karakter dari Admin HO (tanpa strip).',
    codeVerifying: 'Memverifikasi kode…',
    previewReady: 'Periksa data binding di bawah sebelum aktivasi.',
    codeValid: 'Kode valid — periksa data sebelum aktivasi.',
    previewTitle: 'Konfirmasi binding',
    footer: 'Belum punya kode? Hubungi Admin HO.',
    cta: 'Aktivasi',
    verifying: 'Memverifikasi…',
    success: 'Perangkat teraktivasi',
    wrongDeviceType: 'Kode ini bukan untuk HP delman.',
    codeUnknown: 'Kode tidak dikenali.',
    activateFailed: 'Aktivasi gagal. Coba lagi.',
    alreadyBoundTitle: 'HP sudah teraktivasi',
    alreadyBoundAction: 'Lanjut login PIN',
    rebindAction: 'Ganti perangkat',
    rebindHelper: 'Minta Admin HO unbind dulu, lalu masukkan kode baru.',
  },
} as const
